import { Document, Page } from "@react-pdf/renderer";
import { connect, Provider } from "react-redux";
import formatMoney from "../helpers/formatMoney";
import { ChoiceState, getTotalPrice } from "../state/reducers/choiceReducer";
import store from "../state";
import { RootState } from "../state/reducers";
import { FormData } from "../types";
import groupChoicesByPageId from "../helpers/groupChoicesByPageId";
import styles from "./PdfStyles";
import registerFonts from "./registerFonts";
import PdfHeader from "./PdfHeader";
import PdfFooter from "./PdfFooter";
import PdfChoicePages from "./PdfChoicePages";

registerFonts([
  {
    family: "Oswald",
    fonts: [
      {
        src: "https://fonts.gstatic.com/s/oswald/v36/TK3_WkUHHAIjg75cFRf3bXL8LICs1xZogUE.ttf",
      },
    ],
  },
  {
    family: "Montserrat",
    fonts: [
      {
        src: "https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_cJD7g4.ttf",
      },
      {
        src: "https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_dJE7g4.ttf",
        fontWeight: 700,
      },
    ],
  },
]);

interface PdfDocProps {
  choices: ChoiceState;
  total: (withDiscount: boolean) => number;
  formData: FormData;
}

const PdfDoc: React.FC<PdfDocProps> = ({ choices, total, formData }) => {
  const grouped = groupChoicesByPageId(choices);
  const title = "post_title" in formData.post ? formData.post.post_title : "";
  const photoDisclaimer =
    "disclaimers" in formData.post
      ? formData.post.disclaimers.summary_photo_disclaimer
      : "";
  const footerDisclaimer =
    "disclaimers" in formData.post
      ? formData.post.disclaimers.footer_disclaimer
      : "";
  return (
    <Document>
      <Page size="LETTER" style={styles.body}>
        <PdfHeader
          title={title}
          photoDisclaimer={photoDisclaimer}
          imageSrc={formData.image}
          price={formatMoney(total(true))}
          discount={formatMoney(total(false))}
        />
        {formData.entities.pages.allIds.map((id) => (
          <PdfChoicePages
            key={id}
            page={formData.entities.pages.byId[id]}
            choicesGroupedByPage={grouped[id]}
          />
        ))}
        <PdfFooter disclaimer={footerDisclaimer} />
      </Page>
    </Document>
  );
};

const PdfDocConnect = connect((state: RootState) => {
  return {
    choices: state.choices,
    total: getTotalPrice(state),
    formData: state.formData,
  };
}, {})(PdfDoc);

const PdfDocWrap = () => (
  <Provider store={store}>
    <PdfDocConnect />
  </Provider>
);

export default PdfDocWrap;
